import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mx-1 rounded-md bg-gray-100 px-3 py-1 font-normal text-gray-500 hover:bg-yellow hover:text-white" }
const _hoisted_4 = {
  key: 0,
  class: "text-red"
}

import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  ComboboxLabel,
} from "@headlessui/vue";
import { ChevronUpDownIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { watch } from "vue";
import { ref, computed, PropType } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOptionsCombobox',
  props: {
  disabled: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array as PropType<{ value: string; name: string }[]>,
    default: () => [],
  },
  selected: {
    type: String,
  },
  label: {
    type: String,
  },
  error: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update", "createOption", "deleteOption"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emits = __emit;

const query = ref("");
const selectedOption = ref();
const customOptions = ref<typeof props.options>([]);

watch(
  () => props.selected,
  (value, old) => {
    if (old) {
      return;
    }

    selectedOption.value = props.options.find((option) => option.value === value) || {
      value: value,
      name: value,
    };
  },
  { immediate: true },
);

const filteredData = computed(() => {
  return [...props.options, ...customOptions.value]
    .filter((option) => {
      return option.name.toLowerCase().includes(query.value.toLowerCase());
    })
    .map((option) => ({ ...option }));
});

const createCustomField = (q: string) => {
  const customField = { value: q, name: q };
  customOptions.value.push(customField);
  selectedOption.value = customField;
  query.value = "";

  emits("createOption", customField);
  emits("update", customField);
};

const deleteCustom = (value: string) => {
  customOptions.value = customOptions.value.filter((option) => option.value !== value);

  emits("deleteOption", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Combobox), {
      as: "div",
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedOption).value = $event))
    }, {
      default: _withCtx(() => [
        (__props.label)
          ? (_openBlock(), _createBlock(_unref(ComboboxLabel), {
              key: 0,
              class: "text-sm font-medium leading-6 text-gray-900"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.label), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ComboboxInput), {
            required: "",
            disabled: __props.disabled,
            class: _normalizeClass([!__props.disabled ? 'oai-inputs' : 'overviewInput', 'w-full text-xs ']),
            placeholder: _unref(t)('buttons.search'),
            displayValue: (value) => (value as (typeof options)[number])?.name || query.value,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (query.value = $event.target.value)),
            "aria-autocomplete": "one-time-code",
            autocomplete: "one-time-code",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (createCustomField(query.value)), ["prevent"]), ["enter"]))
          }, null, 8, ["disabled", "class", "placeholder", "displayValue"]),
          (!__props.disabled)
            ? (_openBlock(), _createBlock(_unref(ComboboxButton), {
                key: 0,
                class: "focus:outline-none absolute inset-y-0 right-0 flex items-center rounded-r-md px-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (query.value = ''))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ChevronUpDownIcon), {
                    class: "h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(ComboboxOptions), {
            disabled: __props.disabled,
            class: "focus:outline-none absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-gray-500/5 text-sm",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('update', selectedOption.value)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredData.value, (option, index) => {
                return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                  key: index,
                  value: option,
                  as: "template"
                }, {
                  default: _withCtx(({ active, selected: selectedValue }) => [
                    _createElementVNode("li", {
                      class: _normalizeClass(["align-center relative flex cursor-default select-none items-center justify-between py-2 pl-3 pr-3", {
              'bg-yellow-600 text-white': active,
              'text-gray-900': !active || selectedValue || option.value === selectedValue.value,
            }])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(option.name), 1),
                      (customOptions.value.some((custom) => custom.value === option.value))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "items- center flex p-1 hover:bg-gray-100",
                            onClick: _withModifiers(($event: any) => (deleteCustom(option.value)), ["stop"])
                          }, [
                            _createVNode(_unref(XMarkIcon), { class: "z-50 h-3 w-3 text-xs text-red" })
                          ], 8, _hoisted_2))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128)),
              (query.value !== '' && !filteredData.value.some((custom) => custom.name === query.value))
                ? (_openBlock(), _createBlock(_unref(ComboboxOption), { key: 0 }, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass({
              'relative cursor-default select-none bg-yellow-600 px-4 py-2 font-semibold text-white':
                active,
              'relative cursor-default select-none px-4 py-2 text-gray-900': !active,
            })
                      }, [
                        _createElementVNode("p", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (createCustomField(query.value)))
                        }, [
                          _createTextVNode(_toDisplayString(_unref(t)("buttons.create")) + ": ", 1),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(query.value), 1)
                        ])
                      ], 2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (__props.selected === '' && __props.error)
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t("err.required")), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})